export default __webpack_public_path__ + "static/media/btn-futuristic-primary-side-left.25f913d0.png";